import { Arrange, Button, Spacer } from '@loomhq/lens';
import React from 'react';

import { useClipsState } from './state';

/*
  We will remove these at some point, they are just for testing
  state manipulations before other controls are built out
*/
const TestingClipsControls = (): JSX.Element => {
  const { clips, removeClip, repositionClip, tempSplitLastPlayRange } =
    useClipsState(state => ({
      clips: state.clips,
      removeClip: state.removeClip,
      repositionClip: state.repositionClip,
      tempSplitLastPlayRange: state.tempSplitLastPlayRange,
    }));

  return (
    <Arrange gap="small" autoFlow="row">
      <Spacer top={2} />
      <Arrange gap="small">
        {clips.length > 0 && (
          <Button onClick={() => removeClip(0)}>remove first clip</Button>
        )}
        {clips.length > 1 && (
          <Button onClick={() => repositionClip(0, 1)}>
            swap first two clips
          </Button>
        )}
        {/*
          when getting rid of this "split"" button, we can also remove
          tempSplitLastPlayRange from the state store
        */}
        {clips.length > 0 && (
          <Button onClick={() => tempSplitLastPlayRange()}>
            split last playrange
          </Button>
        )}
      </Arrange>
    </Arrange>
  );
};

export default TestingClipsControls;
